import { useState } from 'react';
import type { ReactNode } from 'react';
import { TopBar } from './TopBar.js';
import { Sidebar } from './Sidebar.js';
import { AppFooter } from './AppFooter.js';
import { TopBarProvider } from '../contexts/TopBarContext.js';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <TopBarProvider>
      <div className="flex flex-col h-full overflow-hidden" style={{ background: 'var(--evo-bg)' }}>
        <TopBar collapsed={collapsed} />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar collapsed={collapsed} />
          <main className="flex-1 overflow-hidden">{children}</main>
        </div>
        <AppFooter collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
      </div>
    </TopBarProvider>
  );
}
